import { ProductParagraph } from '@issuu/silkscreen';
import React, { useState } from 'react';
import LazyLoad from 'react-lazyload';
import styled from 'styled-components';
const PhotoElement = styled.figure `
    margin: 0;
    &:not(:only-child) {
        margin-top: 2em;
        margin-bottom: 2em;
    }
`;
const Image = styled.img `
    opacity: ${props => (props.loaded ? 1 : 0)};
    max-width: 100%;

    transition: opacity 250ms ease-in;

    /* iOS Safari specific value (see https://github.com/issuu/bugs/issues/197): */
    height: intrinsic;
`;
const ImageWrapper = styled.div `
    position: relative;
    margin-bottom: 0.5em;
    width: 100%;
    display: flex;
    justify-content: center;
`;
export const PhotoCaption = styled.figcaption `
    display: flex;
    justify-content: center;
    > p {
        display: inline;
        max-width: 100%;
    }
`;
export const PhotoCredit = styled.figcaption `
    display: flex;
    justify-content: center;
    > p {
        display: inline;
        max-width: 100%;
    }
`;
export const PhotoImage = ({ url, lazyLoadImage, height, width, caption, }) => {
    const [loaded, setLoaded] = useState(false);
    const image = (React.createElement(Image, { alt: caption || '', loaded: loaded, onLoad: () => setLoaded(true), originalHeight: height, originalWidth: width, ref: img => {
            img && img.complete && setLoaded(true);
        }, src: url }));
    return (React.createElement(ImageWrapper, null, lazyLoadImage ? (React.createElement(LazyLoad, { offset: 500, once: true }, image)) : (image)));
};
const Photo = (props) => (React.createElement(PhotoElement, null,
    React.createElement(PhotoImage, { ...props }),
    props.caption && (React.createElement(PhotoCaption, null,
        React.createElement(ProductParagraph, { step: "negative-2" },
            React.createElement("strong", null, props.caption)))),
    props.credit && (React.createElement(PhotoCredit, null,
        React.createElement(ProductParagraph, { step: "negative-2" }, props.credit)))));
export default Photo;
//# sourceMappingURL=Photo.js.map